import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HeroSection from '@/components/dental-tourism/HeroSection';
import ProcessSection from '@/components/dental-tourism/ProcessSection';
import BenefitsSection from '@/components/dental-tourism/BenefitsSection';
import FAQSection from '@/components/dental-tourism/FAQSection';
import ScrollToTop from '@/components/ScrollToTop';
import { initScrollReveal } from '@/utils/scrollReveal';
import { Phone } from 'lucide-react';
import Seo from '@/components/Seo';

const DentalTourism = () => {
  useEffect(() => {
    // Initialize scroll reveal
    const cleanup = initScrollReveal();
    
    // Return cleanup function
    return cleanup;
  }, []);

  return (
    <div className="relative overflow-x-hidden">
      <Seo page="service" service="dental-tourism" />
      {/* Navbar */}
      <Navbar />
      
      {/* Main Content */}
      <main>
        <HeroSection />
        <ProcessSection />
        <BenefitsSection />
        <FAQSection />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Scroll To Top Button */}
      <ScrollToTop />

      {/* Sticky Mobile Call Button */}
      <div className="fixed bottom-4 right-4 bg-dental text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2 z-50 md:hidden">
        <a
          href="tel:+359879800430"
          className="flex items-center justify-center gap-2 bg-dental text-white px-4 py-3 rounded-full shadow-lg hover:bg-dental-dark transition-colors duration-300"
        >
          <Phone className="w-5 h-5" />
          <span className="font-medium">Call Now</span>
        </a>
      </div>
    </div>
  );
};

export default DentalTourism;
